export const professionalContact = [
    {
      icon: <i className="fab fa-linkedin"></i>,
      value: <a href="https://www.linkedin.com/in/vodelina-samatova-72943a247/">LinkedIn</a>
    }
];